import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { volumes } from '../../data/volumes';
import { bonuses } from '../../data/bonuses';
export function Overview() {
  return <section className="bg-paper px-4 py-16 sm:py-24" aria-labelledby="overview-title" data-id="element-295" data-mp="1imt4ye3q01jd">
      <div className="mx-auto max-w-6xl" data-id="element-296" data-mp="1ip5vvgrghm8k">
        <SectionHeading title={<span id="overview-title" data-id="element-298" data-mp="1wkhpfktvl6nw">
              The 6 volumes and 5 bonuses of the <span className="text-brand-dark" data-id="element-299" data-mp="1sk7ledpn8qbo">Critical Care Nursing Blueprint™</span>
            </span>} subtitle="Everything you need to organize your critical care nursing study materials in one structured educational collection." data-id="element-297" data-mp="1wlss1hbl48df" />
        <p className="mx-auto mt-4 max-w-3xl text-center text-base leading-relaxed text-muted" data-id="element-300" data-mp="2ga1woqube6tt">
          From reviewing essential critical care concepts to understanding monitoring parameters and practicing
          clinical reasoning, each volume follows a consistent educational format designed to make complex information
          easier to navigate.
        </p>

        <div className="mt-10 grid gap-5 lg:grid-cols-[1.35fr_1fr]" data-id="element-301" data-mp="3eu8hiw2195jh">
          <div className="rounded-3xl bg-white p-5 shadow-[0_1px_2px_rgba(6,18,41,0.06)] ring-1 ring-navy-900/5 sm:p-8" data-id="element-302" data-mp="3isfmktn4wieu">
            <h3 className="text-xl font-black text-ink sm:text-2xl" data-id="element-303" data-mp="3nqzagzlag49u">6 premium volumes</h3>
            <ol className="mt-5 space-y-3" data-id="element-304" data-mp="3srws9b2dywat">
              {volumes.map(v => <li key={v.number} className="flex items-center gap-3" data-id="element-305" data-mp="1kas3sevlbyp">
                  <span className="flex h-11 w-14 shrink-0 items-center justify-center rounded-xl text-sm font-black text-white" style={{
                backgroundColor: v.color
              }} data-id="element-306" data-mp="6cc1n6knsol1">
                    {v.number}
                  </span>
                  <span className="text-[15px] font-bold leading-snug text-ink sm:text-base" data-id="element-307" data-mp="kc3jjieaqp4b">{v.title}</span>
                </li>)}
            </ol>
          </div>

          <div className="rounded-3xl bg-navy-950 p-5 text-white sm:p-8" data-id="element-308" data-mp="2gd5afk2mntvd">
            <h3 className="text-xl font-black sm:text-2xl" data-id="element-309" data-mp="2bi84wn4k42n8">
              5 exclusive bonuses <span className="text-cta" data-id="element-310" data-mp="2q62zya61ej3h">— free today</span>
            </h3>
            <ul className="mt-5 space-y-4" data-id="element-311" data-mp="2leb5vpno9v8l">
              {bonuses.map(b => <li key={b.number} className="flex items-start gap-3" data-id="element-312" data-mp="2z5pqu21546ia">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-cta text-navy-950" data-id="element-313" data-mp="2z82fsz5bfh4u">
                    <GiftIcon className="h-5 w-5" aria-hidden="true" data-id="element-314" data-mp="393x3w9sb64f0" />
                  </span>
                  <span className="leading-snug" data-id="element-315" data-mp="3452l37uccfuw">
                    <span className="block text-xs font-extrabold uppercase tracking-wider text-brand" data-id="element-316" data-mp="346dnp4c1vhkf">
                      Bonus #{b.number}
                    </span>
                    <span className="text-[15px] font-bold" data-id="element-317" data-mp="19runx9iw7s63">{b.title}</span>
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <SectionCTA label="Yes! I want all 6 volumes + 5 bonuses" note="Instant digital access · One-time payment of $27 USD · No monthly fees" data-id="element-318" data-mp="3qd83b0cq9vlm" />
      </div>
    </section>;
}